import { FC, memo } from 'react'

import { UserAvatar } from '@shared'
import { PLAYER_AVATAR_TYPE } from '@store'

import styles from '../Dialog.module.scss'

type Props = {
  avatar: string
  title: React.ReactNode
  roleplay?: string
}

export const DialogHeader: FC<Props> = memo(function DialogHeader({
  avatar,
  title,
}: Props) {
  return (
    <div className={styles.header}>
      {avatar === PLAYER_AVATAR_TYPE ? (

        <UserAvatar size={34} className={styles.currentUserAvatar} />
      ) : (
        <div className={styles.avatarContainer}>
          <div
            className={styles.avatar}
            style={{ backgroundImage: avatar ? `url(${avatar})` : '' }}
          />
        </div>
      )}

      <div>{title}</div>
    </div>
  )
})
